import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=2fb27f9c&scoped=true"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"
import style0 from "./Cotizacion.vue?vue&type=style&index=0&id=2fb27f9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb27f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb27f9c')) {
      api.createRecord('2fb27f9c', component.options)
    } else {
      api.reload('2fb27f9c', component.options)
    }
    module.hot.accept("./Cotizacion.vue?vue&type=template&id=2fb27f9c&scoped=true", function () {
      api.rerender('2fb27f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/Cotizacion.vue"
export default component.exports